import { PostgrestResponse } from '@supabase/supabase-js';
import { IRestricoesAlimentares } from '../../../types/tables/IRestricoesAlimentares'
import { BaseMultiTenantService } from '../base/BaseMultiTenantService'

/**
 * Serviço para gerenciamento de restrições alimentares
 */
export class RestricoesAlimentaresService extends BaseMultiTenantService<IRestricoesAlimentares> {
  constructor() {
    super('restricoes_alimentares', ['nome', 'descricao'], 'fk_id_organizacao')
  }

  /**
   * Busca restrições ativas
   */
  async getAtivas(organizationId: number): Promise<PostgrestResponse<IRestricoesAlimentares[]>> {
    const { data, error } = await this.client
      .from(this.tableName)
      .select('*')
      .eq(this.organizationIdField, organizationId)
      .eq('ativo', true)
      .is('deleted_at', null)
      .order('nome')

    if (error) {
      throw new Error(`Erro ao buscar restrições ativas: ${error.message}`)
    }

    return { data: data || [], error } as PostgrestResponse<any[]>
  }

  /**
   * Busca restrições de uma pessoa específica
   * Nota: Este método precisará ser ajustado conforme a estrutura real da tabela de relacionamento
   */
  async getByPessoa(_organizationId: number, _pessoaId: number): Promise<any[]> {
    // Como não temos acesso direto à estrutura da tabela de relacionamento,
    // este método deve ser implementado conforme a estrutura real do banco
    console.warn('Método getByPessoa precisa ser implementado conforme estrutura do banco')
    return []
  }

  /**
   * Busca restrições por severidade
   */
  async getBySeveridade(organizationId: number, severidade: string): Promise<PostgrestResponse<IRestricoesAlimentares[]>> {
    const { data, error } = await this.client
      .from(this.tableName)
      .select('*')
      .eq(this.organizationIdField, organizationId)
      .eq('severidade', severidade)
      .eq('ativo', true)
      .is('deleted_at', null)
      .order('nome')

    if (error) {
      throw new Error(`Erro ao buscar restrições por severidade: ${error.message}`)
    }

    return { data: data || [], error } as PostgrestResponse<any[]>
  }
}

export const restricoesAlimentaresService = new RestricoesAlimentaresService()
